import {
  mdiPiggyBankOutline,
  mdiSemanticWeb,
  mdiCashMultiple
} from '@mdi/js'

var sideMenus = [
  // {
  //   title: 'Menu.Swap',
  //   icon: mdiPiggyBankOutline,
  //   to: 'swap',
  // },
  {
    title: 'Menu.Staking',
    icon: mdiCashMultiple,
    to: 'Staking',
  },
  {
    title: 'Menu.Foundation',
    icon: mdiSemanticWeb,
    to: 'foundation'
  }
]

export default sideMenus
